import { useTypedParams } from "react-router-typesafe-routes";

import { ClientEmployeesCard } from "@components/Cards";

import { routes } from "@pages/routes";

export const ClientEmployees = () => {
  const { clientId } = useTypedParams(
    routes.portal.clients.client.clientEmployees,
  );

  return <ClientEmployeesCard clientId={clientId} />;
};
